// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React, { useContext } from "react";

export interface OrderDetailsPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const orderDetailsPageContainerStyles: OrderDetailsPageContainerStyles = {};

const styles = orderDetailsPageContainerStyles;

const OrderDetailsPageContainer = ({ id }: WidgetProps) => {
    const orderDataView = useContext(OrderStateContext);

    return (
        <PageErrorWrapper
            value={orderDataView}
            badRequestMessage={siteMessage("Order_BadRequest")}
            notAuthorizedMessage={siteMessage("Order_NotAuthorized")}
            notFoundMessage={siteMessage("Order_NotFound")}
            extendedStyles={styles.pageErrorWrapper}
            loadFailedTextTestSelector="orderDetails_pageNotFound"
        >
            <OrderLayout id={id} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Order Details",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
    },
};
export default widgetModule;
